exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".download-modal-content---2wF_P {\n  text-align: left; }\n  .download-modal-content---2wF_P .report-type---3fEsA {\n    margin-top: 20px; }\n  .download-modal-content---2wF_P .report-type---3fEsA .header---2ABN5 {\n      font-weight: bold; }\n  .download-modal-content---2wF_P .selection-group---2-Fpu {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border: 1px #a2c4e3 solid;\n    height: 40px; }\n  .download-modal-content---2wF_P .selection-group---2-Fpu .selection---1yI2K {\n      padding: 0 10px; }\n  .download-modal-content---2wF_P .selection-group---2-Fpu .selection---1yI2K label {\n        padding-left: 10px; }\n  .download-modal-content---2wF_P .footer---2p8vs {\n    margin-top: 10px;\n    text-align: right; }\n", ""]);

// exports
exports.locals = {
	"download-modal-content": "download-modal-content---2wF_P",
	"report-type": "report-type---3fEsA",
	"header": "header---2ABN5",
	"selection-group": "selection-group---2-Fpu",
	"selection": "selection---1yI2K",
	"footer": "footer---2p8vs"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/sub-heading/download-report/download-picker.scss
// module id = hwkD
// module chunks = 1